module.exports = __webpack_public_path__ + "static/laptopWorkingDesktop-e34400d13abfb72516e1348e4cc9b5e7.jpg";